import { gql } from '@apollo/client';

import {
  CHARACTERISTICS_FRAGMENT,
  DISCOUNTS_FRAGMENT,
  MARKETING_COPY_FRAGMENT,
  PRICES_FRAGMENT,
} from '../graphql/fragments';

export const GET_CURRENT_ADD_ONS = gql`
  query getCurrentAddOns($input: GetCurrentAddOnsInput) {
    getCurrentAddOns(input: $input) {
      name
      description
      state
      kind
      price
      discountName
      discountEndDate
      discountAmount
      discountType
      priceWithDiscount
      productInstanceId
      isBundle
      isRescindable
      productTypeId
      discountDuration
      attributes {
        value
        crossOut
      }
      externalLink
    }
  }
`;

export const GET_ADDON_OFFERS = gql`
  query getAddOnOffers {
    getAddOnOffers {
      id
      kind
      name
      description
      is_grouped_product
      characteristics {
        ...CharacteristicsFragment
      }
      discounts {
        total_discounts {
          ...DiscountsFragment
        }
        itemized_discounts {
          ...DiscountsFragment
        }
      }
      offer_id
      marketing_copy {
        ...MarketingCopyFragment
      }
      prices {
        ...PricesFragment
      }
      package_types {
        id
        product_types {
          id
          name
          kind
          discounts {
            total_discounts {
              ...DiscountsFragment
            }
            itemized_discounts {
              ...DiscountsFragment
            }
          }
          marketing_copy {
            ...MarketingCopyFragment
          }
          prices {
            ...PricesFragment
          }
        }
      }
    }
  }

  ${CHARACTERISTICS_FRAGMENT}
  ${PRICES_FRAGMENT}
  ${MARKETING_COPY_FRAGMENT}
  ${DISCOUNTS_FRAGMENT}
`;

export const PURCHASE_ADD_ON = gql`
  mutation purchaseAddOn($input: PurchaseAddOnInput!) {
    purchaseAddOn(input: $input) {
      message
      orderId
      rootProductTypeId
    }
  }
`;

export const GET_AVAILABLE_PHONE_NUMBERS = gql`
  query getAvailableTelephoneNumbers($input: GetAvailableTelephoneNumbersInput!) {
    getAvailableTelephoneNumbers(input: $input) {
      phoneNumber
      prefix
    }
  }
`;

export const RESERVE_PHONE_NUMBER = gql`
  mutation reserveTelephoneNumber($input: ReserveTelephoneNumberInput!) {
    reserveTelephoneNumber(input: $input) {
      reservedPhoneNumber
      reservedTime
    }
  }
`;

export const CONFIGURE_ADDON = gql`
  mutation configureAddon($input: ConfigureAddonInput!) {
    configureAddon(input: $input) {
      success
      message
      eicRequired
    }
  }
`;

export const GET_SCRUBBED_ADDRESS = gql`
  query getScrubbedAddress($address: GetScrubbedAddressInput!) {
    getScrubbedAddress(address: $address) {
      addressLines
      municipality
      region
      country
      postalCode
      countryCode
      processStatus
      recommendation
    }
  }
`;

export const REMOVE_ADDON = gql`
  mutation removeAddOn($input: RemoveAddOnInput) {
    removeAddOn(input: $input) {
      message
      orderId
    }
  }
`;

export const GET_EIC_MESSAGES = gql`
  query getEicMessage($input: EicMessageInput!) {
    getEicMessage(input: $input) {
      productTypeId
      eicMessage
      cpqUserConsent
      cpqConsentDatetime
      cpqConsentReferenceId
    }
  }
`;
